export default {
    ARREDONDAMENTO: 'Arredondamento', TRUNCAGEM: 'Truncagem'
}
